import * as actionTypes from "../actionTypes";

const initialState = {
  error: null,
  isTypingAi: false,
  isChatLoad: true,
  errorMsg: '',
  aiAgents: { results: [] },
  chatHistory: [],
  isChatHistoryLoaded: false
};

const aiCompanionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_AI_COMPANIONS:
      const data = payload.page === 1 ? { results: [] } : {}
      return {
        ...state,
        ...data
      };
    case actionTypes.GET_AI_COMPANIONS_SUCCESS:
      return {
        ...state,
        aiAgents: { ...payload, results: payload.results },
      };
    case actionTypes.GET_AI_COMPANIONS_SINGLE_SUCCESS:
      return {
        ...state,
aiAgentId:payload
      };
    case actionTypes.GET_AI_COMPANIONS_ERROR:
      return {
        ...state,
      };
    case actionTypes.CLEAR_AI_COMPANIONS_CHAT:
      return {
        ...state,
        isChatHistoryLoaded: false,
        isChatLoad: true,
        isTypingAi: false,
        errorMsg: '',
        chatHistory: []
      }
    case actionTypes.ADD_DATE_AI_CHAT:
      return {
        ...state,
        errorMsg: '',
        dateAdded: true,
        isChatLoad: false,
        chatHistory: [...state.chatHistory, { type: "date", text: payload }],
      };
    case actionTypes.ADD_NEW_AI_COMPANIONS_CHAT:
      return {
        ...state,
        errorMsg: '',
        isTypingAi: payload?.hitFirstTime ? false : true,
        chatHistory: payload?.hitFirstTime ? [...state.chatHistory] : [...state.chatHistory, { text: payload.text, type: 'user', date: new Date() }],
      };
    case actionTypes.AI_COMPANIONS_CHAT_STREAM_START:
      return {
        ...state,
        chatHistory: [
          ...state.chatHistory,
          {
            type: "assistant",
            text: "",
            streaming: true,
            date: new Date(),
          },
        ],
      };
    case actionTypes.AI_COMPANIONS_CHAT_STREAM_DELTA:
      return {
        ...state,
        isTypingAi: false,
        chatHistory: state.chatHistory.map((m, i, arr) =>
          i === arr.length - 1 && m.type === "assistant" && m.streaming
            ? { ...m, text: payload }
            : m
        ),
      };
    case actionTypes.AI_COMPANIONS_CHAT_STREAM_DONE:
      return {
        ...state,
        isChatLoad: false,
        errorMsg: "",
        isTypingAi: false,
        chatHistory: state.chatHistory.map((m, i, arr) =>
          i === arr.length - 1 && m.type === "assistant"
            ? {
                ...m,
                text: payload.text,
                message_id: payload.message_id,
                streaming: false,
              }
            : m
        ),
      };
    case actionTypes.SEND_AI_COMPANIONS_CHAT_SUCCESS:
      return {
        ...state,
        isChatLoad: false,
        errorMsg: '',
        isTypingAi: false,
        chatHistory: [...state.chatHistory, ...payload],
      };
    case actionTypes.GET_AI_COMPANIONS_CHAT_HISTORY_SUCCESS:
      return {
        ...state,
        errorMsg: '',
        chatHistory: [...state.chatHistory, ...payload],
        isChatHistoryLoaded: true
      };
    case actionTypes.GET_AI_COMPANIONS_CHAT_HISTORY_ERROR:
      return {
        ...state,
        errorMsg: '',
        isChatLoad: false,
        isChatHistoryLoaded: true,
        chatHistory: [],
      };
    case actionTypes.SEND_AI_COMPANIONS_CHAT_ERROR:
      return {
        ...state,
        errorMsg: payload,
        isTypingAi: false,
        chatHistory: state.chatHistory.filter(
          (m, i, arr) =>
            !(i === arr.length - 1 && m.type === "assistant" && m.streaming)
        ),
      };
    case actionTypes.CHAT_LOAD_SUCCESS:
      return {
        ...state,
        isChatLoad: false
      };

    case actionTypes.REMOVE_CHAT_HISTORY_LOADED:
      return {
        ...state,
        isChatHistoryLoaded: false
      };
    case actionTypes.UPDATE_AI_COMPANIONS_CHAT_FEEDBACK_SUCCESS:
      return {
        ...state,
        chatHistory: state.chatHistory.map((item) =>
          item.message_id === payload.message_id ? { ...item, feedback: payload.feedback } : item
        ),
      };

    default:
      return state;
  }
};
export default aiCompanionsReducer
